import axios from "axios";
import store from '../../redux/store';
import * as actions from "./LoginTypes";
import AppConsts from "../../appconst";

export const UserLogin = async (data) => {
    try {
        const response = await axios.post(AppConsts.apiBaseUrl + "/Login/Login", JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json",
                withCredentials: true,
            },
        }).then(response => {
            if (response.data.msg == "success") {
                //GetAntiForgeryToken();
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("user", response.data.userName);
                localStorage.setItem("p_value", response.data.password);
                localStorage.setItem("userId", response.data.userId);
                localStorage.setItem("userCode", response.data.userCode);
                localStorage.setItem("userRole", response.data.userRole);
                localStorage.setItem("email", response.data.email);
                localStorage.setItem("standardPlanHours", response.data.standardPlanHours);
                localStorage.setItem("standardPlanMinutes", response.data.standardPlanMinutes);
                localStorage.setItem("timezone", response.data.timezone ? response.data.timezone : "");
                localStorage.setItem("department", response.data.department ? response.data.department : "");
                localStorage.setItem("division", response.data.division ? response.data.division : "");
                localStorage.setItem("isManager", response.data.isManager === true);
                localStorage.setItem("isMentor", response.data.isMentor === true);
                localStorage.setItem("profilePhoto", response.data.profilePhoto ? response.data.profilePhoto : "");
                localStorage.setItem("authenticated", true);

                store.dispatch({ type: actions.AUTHENTICATED, payload: { isAuthenticated: true } });
                return response.data;
            }
            else {
                return response.data;
            };
        }).catch(error => {
            return { msg: error.message };
        });

        return response;
    }
    catch (err) {
        return { msg: err.message };
    };
};

export const UserLogout = () => {
    localStorage.removeItem("authenticated");
    localStorage.removeItem("user");
    localStorage.removeItem("p_value");
    localStorage.removeItem("token");
    localStorage.removeItem("profilePhoto");
    window.location.reload();
}

export const GetAntiForgeryToken = async () => {
    try {
        var result = await axios({
            method: 'get',
            url: AppConsts.apiBaseUrl + "/Login/GetToken",
            headers: {
                "Content-Type": "application/json"
            },
        })
            .then(response => {
                localStorage.setItem("X-Xsrf-Token", response.data);
                return response.data;
            })
            .catch(err => {
                if (err?.response?.status == 401) {
                    if (!logout) {
                        logout = true;
                        Modal.confirm({
                            content: "Session expired, Please relogin.", cancelButtonProps: { hidden: true },
                            onOk: () => { UserLogout() }
                        });
                    }
                }
                console.log({ content: err.message });
                result = "";
            });
        return result;
    }
    catch (err) {
        console.log({ content: err.message });
        return "";
    };
};

